import { Component } from '@angular/core';

@Component({
  selector: '[app-toolbar]',
  imports: [],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss'
})
export class ToolbarComponent {

}
